<template>
  <div class="flex flex-col">
    <!-- 3 column wrapper -->
    <div class="lg:flex">
      <div class="w-96 mb-4 ">
        <date-time-picker :range="range" class="mb-2 w-96" />
        <div
          class="flex-shrink-0 md:w-96 xl:w-96 lg:w-96 border border-gray-200"
        >
          <div class="flex items-center justify-between">
            <side-panel :root="'device'" class="w-96" />
          </div>
        </div>
      </div>

      <div
        class="mt-2 ml-4 -mr-4 w-full grid grid-cols-1 gap-4 grid-flow-col-dense"
      >
        <div class="space-y-6 col-span-1">

          <span class="rounded-md">
            <!-- Nav -->
            <div class="hidden sm:block">
              <nav class="space-x-4" aria-label="Tabs">
                <a
                  v-if="reportnav.indicators !== undefined ? reportnav.indicators.show: false"
                  @click="nav = 'indicadores'"
                  class="text-gray-700 px-3 py-2 font-medium text-sm rounded-md"
                  :class="nav === 'indicadores' ? 'bg-gray-300' : ''"
                >
                  {{ $t('message.reports.indicador') }}
                </a>
                <a
                  v-if="reportnav.detentions !== undefined ? reportnav.detentions.show: false"
                  @click="nav = 'detenciones'"
                  class="text-gray-700 px-3 py-2 font-medium text-sm rounded-md"
                  :class="nav === 'detenciones' ? 'bg-gray-300' : ''"
                >
                  {{ $t('message.reports.detencion') }}
                </a>
                <a
                  v-if="reportnav.maintenance !== undefined ? reportnav.maintenance.show: false"
                  @click="nav = 'mantenimiento'"
                  class="text-gray-700 px-3 py-2 font-medium text-sm rounded-md"
                  :class="nav === 'mantenimiento' ? 'bg-gray-300' : ''"
                >
                  {{ $t('message.reports.mantenimiento') }}
                </a>
                <a
                  v-if="reportnav.plan !== undefined ? reportnav.plan.show: false"
                  @click="nav = 'plan'"
                  class="text-gray-700 px-3 py-2 font-medium text-sm rounded-md"
                  :class="nav === 'plan' ? 'bg-gray-300' : ''"
                >
                  {{ $t('message.reports.plan') }}
                </a>
                <a
                  v-if="reportnav.disp !== undefined ? reportnav.disp.show: false"
                  @click="nav = 'disp'"
                  class="text-gray-700 px-3 py-2 font-medium text-sm rounded-md"
                  :class="nav === 'disp' ? 'bg-gray-300' : ''"
                >
                  {{ $t('message.reports.disp') }}
                </a>
              </nav>
            </div>
          </span>

          <div class="sm:hidden">
            <!-- Use an "onChange" listener to redirect the user to the selected tab URL. -->
            <select id="tabs" name="tabs" class="block w-full focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md" @change="onChange">
              <option value="indicadores" :selected="nav === 'indicadores'">
                  {{ $t('message.reports.indicador') }}
              </option>

              <option value="detenciones" :selected="nav === 'detenciones'">
                  {{ $t('message.reports.detencion') }}
              </option>

              <option value="mantenimiento" :selected="nav === 'mantenimiento'">
                  {{ $t('message.reports.mantenimiento') }}
              </option>

              <option value="plan" :selected="nav === 'plan'">
                  Cumplimiento Plan
              </option>

              <option value="plan" :selected="nav === 'disp'">
                  Disponibilidad
              </option>
            </select>
          </div>

          <report-indicadores
            v-if="nav == 'indicadores'"
            :range="range"
            :currentDevice="currentDevice"
            :reportnav="reportnav.indicators"
          />
          <report-detenciones
            v-else-if="nav == 'detenciones'"
            :range="range"
            :currentDevice="currentDevice"
            :reportnav="reportnav.detentions"
          />
          <report-mantenimiento
            v-else-if="nav == 'mantenimiento'"
            :range="range"
            :currentDevice="currentDevice"
            :reportnav="reportnav.maintenance"
          />
          <report-plan
            v-else-if="nav == 'plan'"
            :range="range"
            :currentDevice="currentDevice"
            :reportnav="reportnav.plan"
          />
          <report-disponibilidad
            v-else-if="nav == 'disp'"
            :range="range"
            :currentDevice="currentDevice"
            :reportnav="reportnav.disp"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SidePanel from '@/components/SidePanel';
import DateTimePicker from '@/components/DateTimePicker';
import ReportIndicadores from '@/views/reports/Indicadores';
import ReportMantenimiento from '@/views/reports/Mantenimiento';
import ReportDetenciones from '@/views/reports/Detenciones';
import ReportDisponibilidad from '@/views/reports/Disponibilidad';
import ReportPlan from '@/views/reports/Plan';
import axios from 'axios';
import { getUnixTime } from 'date-fns';

export default {
  name: 'reports',
  components: {
    SidePanel,
    DateTimePicker,
    ReportMantenimiento,
    ReportIndicadores,
    ReportDetenciones,
    ReportDisponibilidad,
    ReportPlan
  },
  computed: {
    currentDevice() {
      return this.$store.getters.currentDevice;
    },
    range() {
      return {
        start: this.$store.getters.innerStart,
        end: this.$store.getters.innerEnd
      };
    }
  },
  mounted() {
    this.getReportNav();
    this.fetchCodStates();
  },
  watch: {
    range() {
      this.fetchCodStates();
    },
    tsRange() {
      this.fetchCodStates();
    },
    currentDevice() {
      this.fetchCodStates();
    }
  },
  methods: {
    async fetchCodStates() {
      console.log('fetchCodStates');
      let start = getUnixTime(this.range.start);
      let end = getUnixTime(this.range.end);
      const response = await this.$http.get(
        `codstates?devid=${this.currentDevice.devid}&start=${start}&end=${end}`
      );
      let data = response.data.codstates.map(val => {
        return { y: val.time_s, x: val.desc };
      });
      this.series = [{ name: 'tiempos', data: data }];
      console.log(JSON.parse(JSON.stringify(this.series)));
    },
    async getReportNav() {
      let config = {
        params: this.$store.state.data
      }
      const response = await this.$http.get(`reportnav`, config)
      this.reportnav = await response.data
    },
    async downloadExcel() {
      this.downloading = true;
      let start = getUnixTime(this.range.start);
      let end = getUnixTime(this.range.end);
      // let start = this.tsRange.start * 1000;
      // let end = this.tsRange.end * 1000;
      const url = `reports?report=dets&start=${start}&end=${end}&device=${this.currentDevice.devid}`;
      let response = await this.$http.get(url);
      if (response.status === 200) {
        const url = 'http://lipigas.mtsolutions.io:8080/xlsxreports/' + response.data;
        axios
          .get(url, { responseType: 'blob' })
          .then(r => {
            const blob = new Blob([r.data], {
              type: 'application/vnd.ms-excel'
            });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            console.log('response', response.data);
            link.download = response.data;
            link.click();
            URL.revokeObjectURL(link.href);
          })
          .catch(console.error);
      }
      this.downloading = false;
    },
    onChange(event) {
      this.nav = event.target.value
    }
  },
  data() {
    return {
      reportnav: {},
      labels: [],
      nav: 'indicadores'
    };
  }
};
</script>
